import React from "react";
import "./Leaderboard.scss";

const TDstyle = {
  padding: "3px 6px",
  width: "150px",
};

function Leaderboard() {
  return (
    <div className="leaderboard">
      <div className="tools-challenge">
        <p>
          The Leaderboard has been released. Appreciate all the participants'
          efforts and congratulations to the winners.
        </p>
        <p>Task 1: General Anomaly Detection</p>
        <table border="1" style={{ margin: "0 30px" }}>
          <tr>
            <td style={TDstyle}>Rank</td>
            <td style={TDstyle}>Team Name</td>
            <td style={TDstyle}>Performance: AUC</td>
          </tr>
          <tr>
            <td style={TDstyle}>1</td>
            <td style={TDstyle}>BigFish</td>
            <td style={TDstyle}>89.2</td>
          </tr>
          <tr>
            <td style={TDstyle}>2</td>
            <td style={TDstyle}>MonIIT</td>
            <td style={TDstyle}>87.94</td>
          </tr>
          <tr>
            <td style={TDstyle}>3</td>
            <td style={TDstyle}>DeepBlueAI</td>
            <td style={TDstyle}>86.85</td>
          </tr>
          <tr>
            <td style={TDstyle}>4</td>
            <td style={TDstyle}>SYSU-BAIDU</td>
            <td style={TDstyle}>86.52</td>
          </tr>
          <tr>
            <td style={TDstyle}>5</td>
            <td style={TDstyle}>UHV</td>
            <td style={TDstyle}>85.37</td>
          </tr>
          <tr>
            <td style={TDstyle}>6</td>
            <td style={TDstyle}>GOGOGO</td>
            <td style={TDstyle}>84.09</td>
          </tr>
          <tr>
            <td style={TDstyle}>7</td>
            <td style={TDstyle}>ActionLab</td>
            <td style={TDstyle}>70.92</td>
          </tr>
          <tr>
            <td style={TDstyle}>8</td>
            <td style={TDstyle}>Orange-Control</td>
            <td style={TDstyle}>31.65</td>
          </tr>
        </table>
        <p style={{ marginTop: "20px" }}>Task 2: Specific Anomaly Detection</p>
        <table border="1" style={{ margin: "0 30px" }}>
          <tr>
            <td style={TDstyle}>Rank</td>
            <td style={TDstyle}>Team Name </td>
            <td style={TDstyle}>Performance: MF1</td>
          </tr>
          <tr>
            <td style={TDstyle}>1</td>
            <td style={TDstyle}>SYSU-BAIDU</td>
            <td style={TDstyle}>66.41</td>
          </tr>
          <tr>
            <td style={TDstyle}>2</td>
            <td style={TDstyle}>BigFish</td>
            <td style={TDstyle}>62.11</td>
          </tr>
          <tr>
            <td style={TDstyle}>3</td>
            <td style={TDstyle}>GOGOGO</td>
            <td style={TDstyle}>52.33</td>
          </tr>
          <tr>
            <td style={TDstyle}>4</td>
            <td style={TDstyle}>MonIIT</td>
            <td style={TDstyle}>45.52</td>
          </tr>
          <tr>
            <td style={TDstyle}>5</td>
            <td style={TDstyle}>Orange-Control</td>
            <td style={TDstyle}>40.42</td>
          </tr>
          <tr>
            <td style={TDstyle}>6</td>
            <td style={TDstyle}>UHV</td>
            <td style={TDstyle}>38.36</td>
          </tr>
          <tr>
            <td style={TDstyle}>7</td>
            <td style={TDstyle}>ActionLab</td>
            <td style={TDstyle}>22.2</td>
          </tr>
        </table>
        <p style={{ marginTop: "30px" }}>
          This year's challenge has more than 40 registered teams from around
          the world. However, due to the big challenges in both the tasks and
          the difficult COVID-19 period, only a few outstanding teams
          successfully submitted results by the final deadline.
        </p>
        <ul>
          <li style={{ color: "red" }}>Paper Submission</li>
          <li>Paper submission deadline: 7/13/2020</li>
          <li>Acceptance notification: 7/27/2020</li>
          <li>Camera-ready submission: 8/10/2020</li>
        </ul>
        <p>
          For length, please limit each GC paper to 4 pages with 1-2 extra pages
          for reference only.
        </p>
      </div>
    </div>
  );
}

export default Leaderboard;
